// TutorialPopup.jsx
import React, { useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';
import Cookies from 'js-cookie';

const TutorialPopup = ({ show, onClose, onYes }) => {
  useEffect(() => {
    if (show) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, [show]);

  return (
    <Modal show={show} onHide={onClose} backdrop="static" keyboard={false} centered>
    <Modal.Header className="model-header-tutorial" closeButton>
      <Modal.Title>Need Help Getting Started?</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      Want a quick tour? We’ll walk you through how to use key features like <strong>{window.quote}</strong>, <strong>Help</strong>, and the <strong>Signup Form</strong>.
    </Modal.Body>
    <Modal.Footer>
      <Button variant="secondary" onClick={onClose}>
        No, Don’t Show
      </Button>
      <Button variant="primary" onClick={onYes}>
        Yes, Show Tutorial
      </Button>
    </Modal.Footer>
  </Modal>
  
  );
};

export default TutorialPopup;
